<div >
    <div class="row center-item">
        <div class="col-md-12">
            <app-tooltip *ngIf="mobileQuery.matches || fullScreen == false" class="tooltip-container" [Mensaje]="polygonButtonMsg" [isVisible]="isPolygonButtonMsgVisible" (visibilityChange)="onVisibilityChange($event)"></app-tooltip>
            <app-tooltip *ngIf="mobileQuery.matches || fullScreen == false" class="tooltip-container-top" [Mensaje]="polygonFinishMsg" [isVisible]="!isPolygonButtonMsgVisible"></app-tooltip>
            <button [ngClass]="{'btnPin-polygon': AddPolygonSelected == 'create'}" class="btnPin" mat-raised-button (click)="createPolygonPoints(true); this.fullScreen = false;">
                <p class="color-white center-item"><mat-icon class="example-tab-icon">control_point</mat-icon>
                    Seleccionar Vertices
                </p>
            </button>
        </div>
    </div>

    <div class="row center-item">
        <div class="col-6">
            <app-tooltip *ngIf="mobileQuery.matches || fullScreen == false" class="tooltip-container" [Mensaje]="polygonEditButtonMsg" [isVisible]="isPolygonEditButtonMsgVisible" (visibilityChange)="onVisibilityChange($event)"></app-tooltip>
            <button [ngClass]="{'btnPin-polygon': AddPolygonSelected == 'edit'}" class="btnPin" mat-raised-button (click)="editPolygonPoints()">
                <p class="color-white center-item">
                    <mat-icon class="example-tab-icon">edit</mat-icon> Editar
                </p>
            </button>
        </div>
        <div class="col-6">
            <button class="btnPin" mat-raised-button (click)="deletePolygonPoints()"
                matTooltip="Herramienta de borrado de poligono" matTooltipPosition="right">
                <p class="color-white center-item"><mat-icon class="example-tab-icon">delete</mat-icon> Borrar</p>
            </button>
        </div>
    </div>

</div>